import { DataPointsApiResponse } from '@tableau/metrics-engine';
import { Loadable } from '../models/Loadable';

export type LoadableDataPointsById = { [id: string]: Loadable<DataPointsApiResponse> };

export interface MetricsDataState {
  dataPointsById: LoadableDataPointsById;
}

export const initialState: MetricsDataState = {
  dataPointsById: {},
};
